import React from 'react';
import SafeIcon from '../common/SafeIcon';
import BlogComments from './BlogComments';

export default function ArticleLayout({ post }) {
  return (
    <article className="max-w-4xl mx-auto px-6 py-12 md:py-20">
      <div className="text-center mb-12">
        <span className="px-4 py-2 bg-[var(--bg-surface)] text-[var(--text-main)] border border-[var(--border-subtle)] rounded-full text-[10px] font-black uppercase tracking-[0.2em] shadow-sm mb-8 inline-block">
          {post.category}
        </span>
        
        <h1 className="text-4xl md:text-6xl font-black text-[var(--text-main)] uppercase italic tracking-tighter leading-[1.05] mb-8">
          {post.title}
        </h1>

        <div className="flex items-center justify-center gap-6 text-[11px] font-black uppercase tracking-[0.2em] text-[var(--text-secondary)]">
          <span className="flex items-center gap-2">
            <SafeIcon name="User" className="w-4 h-4 text-brand-cyan" /> {post.author}
          </span>
          <span className="flex items-center gap-2">
            <SafeIcon name="Calendar" className="w-4 h-4 text-brand-green" /> {post.date}
          </span>
        </div>
      </div>

      <div className="w-full aspect-video rounded-3xl overflow-hidden mb-16 shadow-2xl border border-[var(--border-subtle)]">
        <img src={post.image} alt={post.title} className="w-full h-full object-cover" />
      </div>

      <div className="max-w-3xl mx-auto">
        <p className="text-xl md:text-2xl text-[var(--text-main)]/80 font-medium leading-relaxed mb-12 border-l-4 border-brand-cyan pl-6 italic">
          {post.excerpt}
        </p>

        {/* Content Render */}
        <div 
          className="prose prose-lg prose-slate max-w-none 
            prose-headings:font-black prose-headings:uppercase prose-headings:italic prose-headings:tracking-tight prose-headings:text-[var(--text-main)]
            prose-p:text-[var(--text-main)]/80 prose-p:leading-relaxed prose-p:font-medium prose-p:mb-8
            prose-strong:text-[var(--text-main)] prose-strong:font-black
            prose-em:text-[var(--text-main)]/70
            marker:text-brand-cyan"
          dangerouslySetInnerHTML={{ __html: post.content }}
        />

        <BlogComments />
      </div>
    </article>
  );
}